"use client";

import React, { useState, Suspense, useMemo } from "react";
import { usePathname } from "next/navigation";
import { useSelector } from "react-redux";

import { Batch_tour_data, BATCH_TOUR } from "@/data/SiteTour";
import BatchTour from "@/components/guided-tour/batch";
import styles from "./layout.module.scss";
import Components from "@/components";
import utils from "@/utils";

const CourseLayout = ({ children }) => {
  const userDetails = useSelector((state) => state.userDetails);
  const user = useSelector((state) => state?.user?.users);
  const points = useSelector((state) => state.points);
  const pathname = usePathname();

  const [open, setOpen] = useState(false);

  const setCPoints = useMemo(() => {
    if (user?.email) {
      const res = utils.calculateCipherPoints(points);
      let formatString = "";
      if (res < 10) formatString = "0" + res;
      else formatString = res;
      return formatString;
    } else {
      return "0";
    }
  }, [user, points]);

  const batch_tour = Batch_tour_data(userDetails?.batchId);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.cipherschools.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Courses",
        item: "https://www.cipherschools.com/courses",
      },
    ],
  };

  return (
    <>
      {!userDetails?.isTourSeen && userDetails?.batchId ? (
        pathname === "/" || pathname === "/courses" ? (
          <BatchTour stepsData={batch_tour} tourFor={BATCH_TOUR} />
        ) : null
      ) : null}
      <Components.Navbar
        watchPoint={setCPoints}
        onClose={() => setOpen(false)}
        onSideCall={
          pathname.split("/").length === 4 ? null : () => setOpen(!open)
        }
        className={styles["general-sidebar"]}
      />
      {pathname.split("/").length === 4 ? null : (
        <aside>
          <Components.LeftSidebar
            onOpen={open}
            className={
              pathname === "/"
                ? styles["landing-sidebar"]
                : styles["general-sidebar"]
            }
          />
        </aside>
      )}
      <main className={styles.main}>
        <Suspense fallback={<Components.PageLoader />}>{children}</Suspense>
      </main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
};

export default CourseLayout;
